import {
  BlockFromConfigNoChildren,
  InlineContentSchema,
  StyleSchema,
} from "@blocknote/core";
import { useBlockNoteEditor, useComponentsContext } from "@blocknote/react";
import { Flex, Modal, TextInput as MTextInput, Text } from "@mantine/core";
import { useCallback, useState } from "react";
import { block_note_schema } from "../BlockInput";
import { YOUTUBE_CONFIG } from "./config";

export const YoutubeEmbedModal = <
  T extends BlockFromConfigNoChildren<
    typeof YOUTUBE_CONFIG,
    InlineContentSchema,
    StyleSchema
  >
>({
  block,
  opened,
  onClose,
}: {
  block: T;
  opened: boolean;
  onClose: () => void;
}) => {
  const editor = useBlockNoteEditor(block_note_schema);
  const Components = useComponentsContext()!;
  const [currentUrl, setCurrentUrl] = useState("");
  const [error, setError] = useState("");
  const handleUpdateBlock = useCallback(() => {
    const id = youtubeUrlToId(currentUrl);
    if (!id) {
      return setError("Invalid Youtube Url");
    }
    editor.updateBlock(block, {
      props: { videoId: id },
    });
    onClose();
  }, [editor, block, currentUrl]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Set Youtube Url"
      centered
      size={"md"}
    >
      <Flex align="center" direction="column" gap="8px" w="100%">
        <MTextInput
          w="100%"
          className="bn-text-input"
          placeholder="https://youtu.be/jNQXAC9IVRw?si=HcSQ18gHCO-z7UYc"
          value={currentUrl}
          onChange={(e) => {
            setError("");
            setCurrentUrl(e.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleUpdateBlock();
            }
          }}
          error={error}
        />
        {error && <Text>{error}</Text>}
        <Components.FilePanel.Button
          className={"bn-button"}
          onClick={() => handleUpdateBlock()}
        >
          Add Url
        </Components.FilePanel.Button>
      </Flex>
    </Modal>
  );
};

/** From https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
    Matches various link formats
    http://www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
    http://www.youtube.com/user/IngridMichaelsonVEVO#p/a/u/1/QdK8U-VIH_o
    http://www.youtube.com/v/0zM3nApSvMg?fs=1&amp;hl=en_US&amp;rel=0
    http://www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
    http://www.youtube.com/embed/0zM3nApSvMg?rel=0
    http://www.youtube.com/watch?v=0zM3nApSvMg
    http://youtu.be/0zM3nApSvMg
*/

const youtubeUrlToId = (url: string) => {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7]?.length == 11 ? match[7] : false;
};
